import React, { useEffect, useState, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
//CSS
import "./messageCard.css";
//Components
import Button from "../Other Components/button";
import { motion } from "framer-motion";
import { fadeIn, hoverEffect } from "../Other Components/animations";
import useNarrowMode from "../../hooks/useNarrowModeChecker";
import PopupConfirmation from "../Other Components/popupConfirmation";
//Functions and hooks
import { MessageTypes } from "../../BackendAccess/FrontendHelpers";
import { useTranslation } from "react-i18next";

export default function MessageCard({
  MessageID,
  Header,
  Body,
  Type,
  Token,
  Sender,
  DateTime,
  selectedItemIds,
  className = "",
  bBtnVisible = true,
  onClick,
  onAcceptClick,
  bSelectable = false,
  onSelected,
  bDisabled,
}) {
  const isNarrow = useNarrowMode();
  const [btnVisibleLoc, setBtnVisibleLoc] = useState(bBtnVisible);
  const [selected, setSelected] = useState(false);
  const [isLongPress, setIsLongPress] = useState(false);
  const [activeLongPress, setActiveLongPress] = useState(false);

  const [wasLongPress, setWasLongPress] = useState(false);
  const longPressTimer = useRef(null);
  const longPressDuration = 500;

  const { t } = useTranslation();

  const checkedType = Object.values(MessageTypes).includes(Type)
    ? Type
    : MessageTypes.ANNOUNCEMENT;

  useEffect(() => {
    setBtnVisibleLoc(!isNarrow && bBtnVisible);
  }, [isNarrow]);

  useEffect(() => {
    if (selectedItemIds !== undefined) {
      setSelected(selectedItemIds.includes(MessageID));
    }
  }, [selectedItemIds]);

  const handleTouchStart = (e) => {
    if (isNarrow) {
      if (e.type === "mousedown") {
        e.preventDefault();
      }
      e.stopPropagation();

      touchStartTime.current = new Date().getTime();
      longPressTimer.current = setTimeout(() => {
        setIsLongPress(true);
        setWasLongPress(true);
        setActiveLongPress(true);
        onSelectedLocal();
      }, longPressDuration);
    }
  };

  const handleTouchEnd = (e) => {
    if (isNarrow) {
      if (e.type === "mouseup") {
        e.preventDefault();
      }
      e.stopPropagation();

      clearTimeout(longPressTimer.current);

      if (!isLongPress) {
        setWasLongPress(false);
      }

      setIsLongPress(false);
      setActiveLongPress(false);
    }
  };

  const handleTouchMove = () => {
    if (isNarrow) {
      clearTimeout(longPressTimer.current);
      setIsLongPress(false);
      setActiveLongPress(false);
    }
  };

  const touchStartTime = useRef(0);

  const onBodyClick = () => {
    if (!wasLongPress && onClick) {
      onClick();
    }
    setWasLongPress(false);
  };

  const onSelectedLocal = () => {
    const newSelectedState = !selected;
    if (onSelected !== undefined && typeof onSelected === "function")
      onSelected(newSelectedState, MessageID);
  };

  const localAcceptClick = (e) => {
    e.stopPropagation();
    onAcceptClick(MessageID);
  };

  const itemCardClassName =
    className + " message-card " + (selected ? " selected" : " ");

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      key={MessageID}
      variants={fadeIn(0.2)}
      className={itemCardClassName}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchMove={handleTouchMove}
      onMouseDown={isNarrow ? handleTouchStart : undefined}
      onMouseUp={isNarrow ? handleTouchEnd : undefined}
      onMouseLeave={isNarrow ? handleTouchEnd : undefined}
    >
      {!isNarrow && (
        <div
          className={
            "message-card-selected-box" + (selected ? " selected" : " ")
          }
        >
          <div
            className="checkbox-container message-card"
            onClick={() => onSelectedLocal()}
          >
            <div className={"checkbox " + (selected ? "checked" : "")} />
          </div>
        </div>
      )}
      <div
        className={
          "message-card-content" +
          (selected ? " selected" : " ") +
          (isNarrow ? " narrow" : "") +
          (activeLongPress ? " active-longpress" : "")
        }
        onClick={() => onBodyClick()}
      >
        <span className="message-card-header">{Header}</span>
        <div className="message-card-body-content">
          <p className="message-card-body-text">{Body}</p>
          {btnVisibleLoc ? (
            <div className="message-card-btn-section">
              {checkedType === MessageTypes.REQUEST ? (
                <Button
                  btnStyle={"btn-positive"}
                  icon="apply"
                  onClick={localAcceptClick}
                >
                  {t("Accept", { ns: "messages" })}
                </Button>
              ) : null}
            </div>
          ) : null}
        </div>
        <div className="message-card-footer">
          <span className="message-card-from-section">
            {t("Sender", { ns: "messages" }) + ": " + Sender}
          </span>
          {isNarrow ? null : (
            <span className="message-card-datetime-section">
              {t("Date and time", { ns: "messages" }) + ": " + DateTime}
            </span>
          )}
        </div>
      </div>
    </motion.div>
  );
}
